const IntegerOnly = (value, min, max) => {
    const newvalue = value.replace(new RegExp(/[^\d]/, "ig"), "")
    if (Number(newvalue) < min)
        return Number(min)
    if  (Number(newvalue) > max)
        return Number(max)
    return Number(newvalue)
}

export default IntegerOnly